import { el } from "./dom.js";
import { MAG, magButton } from "./magazine/kit.js";

// ISBN barcode scanner (roadmap #42): the camera + the browser's own
// BarcodeDetector (Chrome / Edge / Samsung on Android; not Safari yet). Where
// it's missing the button isn't shown — typing the ISBN works everywhere.

export function canScanBarcodes() {
	return typeof window !== "undefined" && "BarcodeDetector" in window && !!navigator.mediaDevices?.getUserMedia;
}

// An ISBN-10/13 typed or scanned → digits only; null when it isn't one.
export function isbnFrom(text) {
	const s = String(text ?? "").replace(/[\s-]/g, "").toUpperCase();
	return /^(\d{9}[\dX]|97[89]\d{10})$/.test(s) ? s : null;
}

// Opens a full-screen camera view; resolves the first ISBN seen, or null.
export async function scanIsbn() {
	const detector = new window.BarcodeDetector({ formats: ["ean_13", "ean_8", "upc_a"] });
	const stream = await navigator.mediaDevices.getUserMedia({ video: { facingMode: "environment" }, audio: false });
	const video = el("video", { autoplay: true, playsinline: true, muted: true, style: { width: "100%", maxHeight: "70vh", objectFit: "cover", borderRadius: "14px" } });
	video.srcObject = stream;
	let done = false;
	let finish;
	const result = new Promise((res) => (finish = res));
	const close = (value) => {
		if (done) return;
		done = true;
		for (const t of stream.getTracks()) t.stop();
		overlay.remove();
		finish(value);
	};
	const overlay = el("div", {
		role: "dialog",
		"aria-label": "Scan a book's barcode",
		style: {
			position: "fixed", inset: "0", zIndex: "1000", background: "rgba(5,5,8,.94)", display: "flex", flexDirection: "column",
			alignItems: "center", justifyContent: "center", gap: "14px", padding: "16px",
		},
	},
	el("div", { style: { fontFamily: "'Anton', sans-serif", fontSize: "24px", color: "#fff", textTransform: "uppercase" } }, "Scan the barcode"),
	el("div", { style: { position: "relative", width: "100%", maxWidth: "480px" } },
		video,
		el("div", { "aria-hidden": "true", style: { position: "absolute", left: "10%", right: "10%", top: "45%", height: "3px", background: MAG.lime, boxShadow: `0 0 12px ${MAG.lime}` } })),
	el("div", { style: { fontFamily: "'Archivo', sans-serif", fontSize: "12.5px", color: MAG.dim, textAlign: "center" } }, "Hold the back of the book steady, barcode across the line."),
	magButton("Cancel", { variant: "ghost", onClick: () => close(null) }));
	document.body.append(overlay);

	const tick = async () => {
		if (done) return;
		try {
			if (video.readyState >= 2) {
				for (const code of await detector.detect(video)) {
					const isbn = isbnFrom(code.rawValue);
					if (isbn) return close(isbn);
				}
			}
		} catch {
			// a frame that couldn't be read — keep going
		}
		setTimeout(tick, 250);
	};
	tick();
	return result;
}
